import React, { useEffect } from "react";

import AccountModal from "../../login/AccountModal";

import "./user-login.m.css";

const UserLoginPage = () => {
  useEffect(() => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_page_info",
        category: "NA",
        sub_category: "NA",
        content_id: "NA",
        template_name: "User Login",
        login_status: "not-logged-in",
        subscription_status: "not-subscribed", // will be changed
        ad_free: false, // will be changed
        login_wall_enabled: false,
        platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
      });
    }
  }, []);

  return (
    <div styleName="wrapper">
      <AccountModal isPopup={false} />
    </div>
  );
};

export { UserLoginPage };
